(() => {
  'use strict';
  if (window.__krolCodeAdapter) return;
  window.__krolCodeAdapter = true;
  const invoke = (method, value) => {
    if (window.KorolGift) return window.KorolGift[method](value).catch(() => {});
    document.addEventListener('korol-gift:ready', () => { window.KorolGift[method](value).catch(() => {}); }, { once: true });
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const apply = event.target.closest('[data-kw-apply]');
    if (apply) { event.preventDefault(); invoke('applyCode', apply.closest('[data-kw-code-box]').querySelector('[data-kw-code-input]').value); }
    if (event.target.closest('[data-kw-remove]')) { event.preventDefault(); invoke('removeCode'); }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches('[data-kw-code-input]')) return;
    event.preventDefault(); invoke('applyCode', event.target.value);
  });
})();
